import * as React from "react"
import {
  StyledPanelActions,
  StyledPanelBodySection,
  Text,
} from "gatsby-interface"
import { FormElement, FormFields } from "@modules/form/components/Form"

export type ConnectCmsFormLayoutProps = {
  description?: React.ReactNode
  children: React.ReactNode
  controls: React.ReactNode
}

export function ConnectCmsFormLayout({
  description,
  children,
  controls,
}: ConnectCmsFormLayoutProps) {
  return (
    <FormElement
      css={{
        flexGrow: 1,
        display: `flex`,
        flexDirection: `column`,
      }}
    >
      <div css={{ flexGrow: 1 }}>
        <StyledPanelBodySection>
          <FormFields>
            {description && <Text css={{ margin: 0 }}>{description}</Text>}
            {children}
          </FormFields>
        </StyledPanelBodySection>
      </div>
      <StyledPanelActions>{controls}</StyledPanelActions>
    </FormElement>
  )
}
